// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../node_modules/@aws-amplify/ui-react/dist/styles.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
  aws authenticator component - style overrides
  see: https://ui.docs.amplify.aws/react/theming/css-variables
*/
html body .placemakr-ibe [data-amplify-authenticator] {
  /* font colors */
  --amplify-colors-font-primary: #122634;

  /* border colors */
  --amplify-colors-border-primary: #d1d5db;
  --amplify-colors-border-focus: #d1d5db;
  --amplify-colors-border-disabled: #d1d5db;
  --amplify-colors-border-error: #d1d5db;

  /* authenticator */
  --amplify-components-authenticator-router-border-color: #d1d5db;
  --amplify-components-authenticator-container-width-max: 100%;

  /* field controls */
  --amplify-components-field-font-size: 0.9rem;
  --amplify-components-fieldcontrol-border-radius: 0.5rem;
  --amplify-components-fieldcontrol-border-color: #d1d5db;
  --amplify-components-fieldcontrol-active-border-color: #122634;
  --amplify-components-fieldcontrol-focus-border-color: #122634;
  --amplify-components-fieldcontrol-hover-border-color: #122634;
  --amplify-components-fieldcontrol-focus-box-shadow: #122634;

  /* text fields */
  --amplify-components-textfield-border-color: #d1d5db;
  --amplify-components-textfield-active-border-color: #122634;
  --amplify-components-textfield-focus-border-color: #122634;
  --amplify-components-textfield-hover-border-color: #122634;

  /* buttons */
  --amplify-components-button-primary-color: #122634;
  --amplify-components-button-primary-background-color: #b2ece7;
  --amplify-components-button-primary-active-color: #455966;
  --amplify-components-button-primary-active-background-color: #b2ece7;
  --amplify-components-button-primary-focus-color: #455966;
  --amplify-components-button-primary-focus-background-color: #b2ece7;
  --amplify-components-button-primary-hover-color: #455966;
  --amplify-components-button-primary-hover-background-color: #b2ece7;
  --amplify-components-button-border-radius: 0.5rem;

  /* button links */
  --amplify-components-button-link-color: #122634;
  --amplify-components-button-link-active-color: #122634;
  --amplify-components-button-link-active-background-color: transparent;
  --amplify-components-button-link-focus-color: #122634;
  --amplify-components-button-link-focus-background-color: transparent;
  --amplify-components-button-link-hover-color: #122634;
  --amplify-components-button-link-hover-background-color: transparent;
}

/* hide border/shadow for authenticator component */
html body .placemakr-ibe [data-amplify-authenticator] [data-amplify-router] {
  box-shadow: none;
  border-style: none;
}

/* remove form padding in authenticator component */
html body .placemakr-ibe [data-amplify-authenticator] [data-amplify-form] {
  padding: 0px;
}

/* hide tabs for authenticator component */
html body .placemakr-ibe [data-amplify-authenticator] .amplify-tabs {
  display: none;
}

html body .placemakr-ibe [data-amplify-authenticator] .amplify-heading--3{
  font-size: 1.125rem;
  line-height: 1.75rem;
}

html body .placemakr-ibe [data-amplify-authenticator] .amplify-heading--4{
  font-size: 1rem;
  line-height: 1.5rem;
}

html body .placemakr-ibe [data-amplify-authenticator] input[type='number']::-webkit-inner-spin-button, html body .placemakr-ibe [data-amplify-authenticator] input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

html body .placemakr-ibe [data-amplify-authenticator] button.amplify-button{
  --tw-border-opacity: 1;
  border-color: var(--fallback-s,oklch(var(--s)/var(--tw-border-opacity)));
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  text-transform: lowercase;
  --tw-text-opacity: 1;
  color: var(--fallback-p,oklch(var(--p)/var(--tw-text-opacity)));
}

html body .placemakr-ibe [data-amplify-authenticator] button.amplify-button:hover{
  --tw-bg-opacity: 1;
  background-color: var(--fallback-s,oklch(var(--s)/var(--tw-bg-opacity)));
}

html body .placemakr-ibe [data-amplify-authenticator] button.amplify-button {
  --amplify-font-weights-normal: 600;
}

@media (hover: hover){
  html body .placemakr-ibe [data-amplify-authenticator] button.amplify-button--link:hover{
    border-color: transparent;
  }
  @supports (color: oklch(0 0 0)){
    html body .placemakr-ibe [data-amplify-authenticator] button.amplify-button--link:hover{
      background-color: var(--fallback-bc,oklch(var(--bc)/0.2));
    }
  }
  html body .placemakr-ibe [data-amplify-authenticator] button.amplify-button--link:hover{
    border-color: transparent;
  }
  @supports (color: oklch(0 0 0)){
    html body .placemakr-ibe [data-amplify-authenticator] button.amplify-button--link:hover{
      background-color: var(--fallback-bc,oklch(var(--bc)/0.2));
    }
  }
}

html body .placemakr-ibe [data-amplify-authenticator] button.amplify-button--link{
  border-width: 1px;
  border-color: transparent;
  background-color: transparent;
  color: currentColor;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  outline-color: currentColor;
}

html body .placemakr-ibe [data-amplify-authenticator] button.amplify-button--link.btn-active{
  border-color: transparent;
  background-color: var(--fallback-bc,oklch(var(--bc)/0.2));
}

html body .placemakr-ibe [data-amplify-authenticator] button.amplify-button--link{
  margin-top: 0.25rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/authenticator.css"],"names":[],"mappings":"AAEA;;;CAGC;AACD;EACE,gBAAgB;EAChB,sCAAsC;;EAEtC,kBAAkB;EAClB,wCAAwC;EACxC,sCAAsC;EACtC,yCAAyC;EACzC,sCAAsC;;EAEtC,kBAAkB;EAClB,+DAA+D;EAC/D,4DAA4D;;EAE5D,mBAAmB;EACnB,4CAA4C;EAC5C,uDAAuD;EACvD,uDAAuD;EACvD,8DAA8D;EAC9D,6DAA6D;EAC7D,6DAA6D;EAC7D,2DAA2D;;EAE3D,gBAAgB;EAChB,oDAAoD;EACpD,2DAA2D;EAC3D,0DAA0D;EAC1D,0DAA0D;;EAE1D,YAAY;EACZ,kDAAkD;EAClD,6DAA6D;EAC7D,yDAAyD;EACzD,oEAAoE;EACpE,wDAAwD;EACxD,mEAAmE;EACnE,wDAAwD;EACxD,mEAAmE;EACnE,iDAAiD;;EAEjD,iBAAiB;EACjB,+CAA+C;EAC/C,sDAAsD;EACtD,qEAAqE;EACrE,qDAAqD;EACrD,oEAAoE;EACpE,qDAAqD;EACrD,oEAAoE;AACtE;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;EACE,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,aAAa;AACf;;AAGE;EAAA,mBAAc;EAAd;AAAc;;AAId;EAAA,eAAgB;EAAhB;AAAgB;;AAGlB;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAGE;EAAA,sBAAoE;EAApE,wEAAoE;EAApE,mBAAoE;EAApE,oBAAoE;EAApE,gBAAoE;EAApE,yBAAoE;EAApE,oBAAoE;EAApE;AAAoE;;AAIpE;EAAA,kBAAmB;EAAnB;AAAmB;;AAGrB;EACE,kCAAkC;AACpC;;AAGE;EAAA;IAAA;EAAqB;EAArB;IAAA;MAAA;IAAqB;EAAA;EAArB;IAAA;EAAqB;EAArB;IAAA;MAAA;IAAqB;EAAA;AAAA;;AAArB;EAAA,iBAAqB;EAArB,yBAAqB;EAArB,6BAAqB;EAArB,mBAAqB;EAArB,sBAAqB;EAArB,8BAAqB;EAArB,uGAAqB;EAArB;AAAqB;;AAArB;EAAA,yBAAqB;EAArB;AAAqB;;AAArB;EAAA;AAAqB","sourcesContent":["@import '@aws-amplify/ui-react/styles.css';\n\n/* \n  aws authenticator component - style overrides\n  see: https://ui.docs.amplify.aws/react/theming/css-variables\n*/\n[data-amplify-authenticator] {\n  /* font colors */\n  --amplify-colors-font-primary: #122634;\n\n  /* border colors */\n  --amplify-colors-border-primary: #d1d5db;\n  --amplify-colors-border-focus: #d1d5db;\n  --amplify-colors-border-disabled: #d1d5db;\n  --amplify-colors-border-error: #d1d5db;\n\n  /* authenticator */\n  --amplify-components-authenticator-router-border-color: #d1d5db;\n  --amplify-components-authenticator-container-width-max: 100%;\n\n  /* field controls */\n  --amplify-components-field-font-size: 0.9rem;\n  --amplify-components-fieldcontrol-border-radius: 0.5rem;\n  --amplify-components-fieldcontrol-border-color: #d1d5db;\n  --amplify-components-fieldcontrol-active-border-color: #122634;\n  --amplify-components-fieldcontrol-focus-border-color: #122634;\n  --amplify-components-fieldcontrol-hover-border-color: #122634;\n  --amplify-components-fieldcontrol-focus-box-shadow: #122634;\n\n  /* text fields */\n  --amplify-components-textfield-border-color: #d1d5db;\n  --amplify-components-textfield-active-border-color: #122634;\n  --amplify-components-textfield-focus-border-color: #122634;\n  --amplify-components-textfield-hover-border-color: #122634;\n\n  /* buttons */\n  --amplify-components-button-primary-color: #122634;\n  --amplify-components-button-primary-background-color: #b2ece7;\n  --amplify-components-button-primary-active-color: #455966;\n  --amplify-components-button-primary-active-background-color: #b2ece7;\n  --amplify-components-button-primary-focus-color: #455966;\n  --amplify-components-button-primary-focus-background-color: #b2ece7;\n  --amplify-components-button-primary-hover-color: #455966;\n  --amplify-components-button-primary-hover-background-color: #b2ece7;\n  --amplify-components-button-border-radius: 0.5rem;\n\n  /* button links */\n  --amplify-components-button-link-color: #122634;\n  --amplify-components-button-link-active-color: #122634;\n  --amplify-components-button-link-active-background-color: transparent;\n  --amplify-components-button-link-focus-color: #122634;\n  --amplify-components-button-link-focus-background-color: transparent;\n  --amplify-components-button-link-hover-color: #122634;\n  --amplify-components-button-link-hover-background-color: transparent;\n}\n\n/* hide border/shadow for authenticator component */\n[data-amplify-authenticator] [data-amplify-router] {\n  box-shadow: none;\n  border-style: none;\n}\n\n/* remove form padding in authenticator component */\n[data-amplify-authenticator] [data-amplify-form] {\n  padding: 0px;\n}\n\n/* hide tabs for authenticator component */\n[data-amplify-authenticator] .amplify-tabs {\n  display: none;\n}\n\n[data-amplify-authenticator] .amplify-heading--3 {\n  @apply text-lg;\n}\n\n[data-amplify-authenticator] .amplify-heading--4 {\n  @apply text-base;\n}\n\n[data-amplify-authenticator] input[type='number']::-webkit-inner-spin-button,\n[data-amplify-authenticator] input[type='number']::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n[data-amplify-authenticator] button.amplify-button {\n  @apply border-secondary text-primary text-sm lowercase font-semibold;\n}\n\n[data-amplify-authenticator] button.amplify-button:hover {\n  @apply bg-secondary;\n}\n\n[data-amplify-authenticator] button.amplify-button {\n  --amplify-font-weights-normal: 600;\n}\n\n[data-amplify-authenticator] button.amplify-button--link {\n  @apply btn-ghost mt-1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
